export const END_POINT = "https://n0d3-xk72-q91-vm84-rx71-zp42-k18v-q57m.deepwavetechnologies.ai/";
export const FRONT_SITE_URL = "https://deepwavetechnologies.ai";
export const IMAGE_END_POINT = "https://n0d3-xk72-q91-vm84-rx71-zp42-k18v-q57m.deepwavetechnologies.ai";
export const ProjectName = "Deep wave";

export const drawerOnglets = [
  {
    name: "Dashboard",
    icon: "bi-columns-gap",
    to: "/",
    showOnlyToAdmin: false,
    view: "dashboard",
  },
  //{
  //  name: "Projets",
  //  icon: " bi-file-earmark-fill",
  //  to: "/projets",
  //  showOnlyToAdmin: false,
  //  view: "projets",
  // },
  // {
  //   name: "Projet",
  //  icon: "bi-file-earmark-code",
  //  hideInDrawer: true,
  //   to: "/projets/:id",
  //  showOnlyToAdmin: false,
  //  view: "projetItem",
  // },

  //{
   // name: "Blog",
    //icon: "bi-file-earmark-fill",
    //to: "/blog",
    //showOnlyToAdmin: false,
    //view: "blog",
  //},
  // {
  //  name: "Réalisation",
  // icon: "bi-calendar-event",
  //  to: "/realisation",
  // showOnlyToAdmin: false,
  //  view: "events",
  // },
  {
    name: "Pages",
    icon: "bi-file-earmark-code",
    to: "/pages",
    showOnlyToAdmin: false,
    view: "pages",
  },

  // {
  //   name: "Revendeur",
  //   icon: "bi-pin-map",
  //   to: "/showroom",
  //   showOnlyToAdmin: false,
  //   view: "revendeurs",
  // },

  {
    name: "Contacts",
    icon: "bi-envelope-fill",
    to: "/contact",
    showOnlyToAdmin: false,
    view: "contacts",
  },
  {
    name: "Files",
    icon: "bi-card-image",
    to: "/files",
    showOnlyToAdmin: false,
    view: "fichiers",
  },
  {
    name: "Users",
    icon: "bi-people-fill",
    to: "/users",
    showOnlyToAdmin: true,
    view: "users",
  },
  {
    name: "My Account",
    icon: "bi-person-circle",
    to: "/account",
    showOnlyToAdmin: false,
    view: "account",
  },

  //NOT SHOW IN DRAWER

  {
    name: "Articles element",
    hideInDrawer: true,
    to: "/blog/:id",
    showOnlyToAdmin: false,
    view: "articleItem",
  },



  // {
  //  name: "Events element",
  //  hideInDrawer: true,
  //  to: "/realisation/:id",
  //  showOnlyToAdmin: false,
  //  view: "eventItem",
  // },

  // {
  //   name: "Revendeurs element",
  //   hideInDrawer: true,
  //   to: "/showroom/:id",
  //   showOnlyToAdmin: false,
  //   view: "showRoomItem",
  // },

  {
    name: "Pages element",
    hideInDrawer: true,
    to: "/pages/:id",
    showOnlyToAdmin: false,
    view: "pageItem",
  },
  {
    name: "Contact element",
    hideInDrawer: true,
    to: "/contact/:id",
    showOnlyToAdmin: false,
    view: "contactItem",
  },
  {
    name: "New User",
    hideInDrawer: true,
    to: "/newUser",
    showOnlyToAdmin: true,
    view: "newUser",
  },
];

export const pageNames = {
  //  blog: "blog",
  // events: "Realisation",
  //  home: "Accueil",
  /* products: "Page nos biens", */
  // magasins: "Page Revendeur",
};
export const redirection = {
  // eventRoute: "article",
  //blogRoute: "article",
};